// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerModal {
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px -4px 8px rgba(0, 0, 0, 0.05);
  position: absolute;
  z-index: 12;
  min-width: 270px;
  padding: 10px;
  top: 59px;
  right: 78px;
}

.subContainer {
  display: flex;
  background-color: #f1f1f1;
  justify-items: center;
  align-items: center;
  height: 75px;
  min-width: 50px;
  justify-content: start;
  padding-left: 0px;
  padding-right: 5px;
}

.subContainer img {
  width: 45px;
  height: 45px;
  margin-left: 5px;
}

.detals-name {
  display: flex;
  flex-direction: column;
  margin-left: 3px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px;
}

.name {
  font-size: 14px;
  font-weight: 500;
}

.email {
  font-size: 13px;
  font-weight: 500;
  color: #007bc0;
}

.modalLogouts {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin-left: 0px !important;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 18px solid transparent;
  border-right: 18px solid transparent;
  border-bottom: 18px solid white;
  position: absolute;
  top: -8px;
  left: 20px;
  z-index: 10;
}

.logoutButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/modalProfile/modalProfile.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4EAA4E;EAC5E,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB","sourcesContent":[".containerModal {\n  background-color: white;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px -4px 8px rgba(0, 0, 0, 0.05);\n  position: absolute;\n  z-index: 12;\n  min-width: 270px;\n  padding: 10px;\n  top: 59px;\n  right: 78px;\n}\n\n.subContainer {\n  display: flex;\n  background-color: #f1f1f1;\n  justify-items: center;\n  align-items: center;\n  height: 75px;\n  min-width: 50px;\n  justify-content: start;\n  padding-left: 0px;\n  padding-right: 5px;\n}\n\n.subContainer img {\n  width: 45px;\n  height: 45px;\n  margin-left: 5px;\n}\n\n.detals-name {\n  display: flex;\n  flex-direction: column;\n  margin-left: 3px;\n}\n\n.title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 0px;\n}\n\n.name {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.email {\n  font-size: 13px;\n  font-weight: 500;\n  color: #007bc0;\n}\n\n.modalLogouts {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  margin-left: 0px !important;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow-up {\n  width: 0;\n  height: 0;\n  border-left: 18px solid transparent;\n  border-right: 18px solid transparent;\n  border-bottom: 18px solid white;\n  position: absolute;\n  top: -8px;\n  left: 20px;\n  z-index: 10;\n}\n\n.logoutButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
